/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const getUser = /* GraphQL */ `
  query GetUser($id: ID!) {
    getUser(id: $id) {
      id
      first_name
      last_name
      email
      phone_number
      stripe_id
      subscription_id
      subscription_status
      user_group
      createdAt
      updatedAt
      owner
    }
  }
`;
export const listUsers = /* GraphQL */ `
  query ListUsers(
    $filter: ModelUserFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listUsers(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        first_name
        last_name
        email
        phone_number
        stripe_id
        subscription_id
        subscription_status
        user_group
        createdAt
        updatedAt
        owner
      }
      nextToken
    }
  }
`;
export const getResume = /* GraphQL */ `
  query GetResume($id: ID!) {
    getResume(id: $id) {
      id
      applications_id
      application_details {
        name
        tags
      }
      contact_information {
        name
        email
        phone_number
        location
      }
      experiences {
        position
        company
        location
        start_date
        end_date
        description
      }
      education {
        school
        degree
        concentration_1
        concentration_2
        graduation_date
        GPA
      }
      skills {
        skills
      }
      projects {
        name
        link
        description
      }
      additional_links {
        name
        link
      }
      references {
        name
        relationship
        email
      }
      createdAt
      updatedAt
      owner
    }
  }
`;
export const listResumes = /* GraphQL */ `
  query ListResumes(
    $filter: ModelResumeFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listResumes(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        applications_id
        application_details {
          name
          tags
        }
        contact_information {
          name
          email
          phone_number
          location
        }
        experiences {
          position
          company
          location
          start_date
          end_date
          description
        }
        education {
          school
          degree
          concentration_1
          concentration_2
          graduation_date
          GPA
        }
        skills {
          skills
        }
        projects {
          name
          link
          description
        }
        additional_links {
          name
          link
        }
        references {
          name
          relationship
          email
        }
        createdAt
        updatedAt
        owner
      }
      nextToken
    }
  }
`;
export const userByStripeID = /* GraphQL */ `
  query UserByStripeID(
    $stripe_id: String
    $sortDirection: ModelSortDirection
    $filter: ModelUserFilterInput
    $limit: Int
    $nextToken: String
  ) {
    userByStripeID(
      stripe_id: $stripe_id
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        first_name
        last_name
        email
        phone_number
        stripe_id
        subscription_id
        subscription_status
        user_group
        createdAt
        updatedAt
        owner
      }
      nextToken
    }
  }
`;
